import { useContext } from "react";
import Scrollbar from "src/components/common/Scrollbar";
import { SidebarContext } from "src/contexts/SidebarContext";
import Logo from "src/components/common/LogoSign";
import {
	Box,
	Drawer,
	alpha,
	styled,
	Divider,
	useTheme,
	lighten,
	darken,
	Typography,
	Button,
} from "@mui/material";
import SidebarMenu from "./SidebarMenu";
import UserBox from "src/components/common/UserBox";
import { isLoggedIn } from "src/services/auth.service";
import { useParams } from "react-router";
import { getContactPersonNumber } from "src/utils/Contact";

function Sidebar() {
	const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
	const closeSidebar = () => toggleSidebar();
	const theme = useTheme();
	const { courseId } = useParams();
	const detailCourse = location.pathname.includes("/classes/e-course");
	const detailClassRoom = location.pathname.includes("/classes/classroom");
	
	const SidebarWrapper = styled(Box)(
		({ theme }) => ({
			width: theme.sidebar.width,
			minWidth: theme.sidebar.width,
			color: theme.colors.alpha.trueWhite[70],
			position: "relative",
			zIndex: 7,
			// height: ,
			[theme.breakpoints.down("lg")]: {
				height: "100%",
			},
			[theme.breakpoints.up("lg")]: {
				height: ((detailCourse || detailClassRoom) && courseId) ? "calc(100vh - 26.1%)" : "100%",
				maxHeight: ((detailCourse || detailClassRoom) && courseId) ? "100%" : "100%",
			},
		})
	);
	
	return (
		<>
			<SidebarWrapper
				sx={{
					display: {
						xs: "none",
						lg: "inline-block",
					},
					position: "fixed",
					left: 0,
					top: 0,
					background:
						theme.palette.mode !== "dark"
							? alpha(lighten(theme.header.background, 0.1), 0.5)
							: darken(theme.colors.alpha.black[100], 0.5),
					boxShadow:
						theme.palette.mode !== "dark" ? theme.sidebar.boxShadow : "none",
				}}>
				<Scrollbar>
					<Box
						pt={2}
						pl={2}
						pb={2}
						mx={1}
						sx={{
							width: 265,
							position: "fixed",
							zIndex: 999,
							background: "#F9FAFC",
							boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.05)",
							padding: "22px 34px",
						}}>
						<Logo />
					</Box>
					<Box pt={10}>{isLoggedIn() && <UserBox nameUser={true} />}</Box>
					<Divider
						sx={{
							mt: theme.spacing(3),
							mx: theme.spacing(2),
							background: theme.colors.alpha.trueWhite[10],
						}}
					/>
					<SidebarMenu />
				</Scrollbar>
				{
					((detailCourse || detailClassRoom) && courseId) &&
						<Box
							sx={{
								backgroundImage: `url("/bg-help.svg")`,
								height: "35%", // Kurangi tinggi box agar lebih proporsional
								minHeight: 120, // Sesuaikan minimum tinggi
								maxHeight: 180, // Sesuaikan maksimum tinggi
								backgroundSize: "cover", // Pastikan gambar tidak terpotong
								backgroundPosition: "center",
								backgroundRepeat: "no-repeat",
								display: "flex",
								flexDirection: "column",
								justifyContent: "end",
								paddingLeft: "20px", // Kurangi padding agar lebih proporsional
								paddingBottom: "8px", // Kurangi padding bawah
								overflow: "hidden !important",
							}}
						>
							<img
								src="/help.svg"
								alt="At work"
								style={{
									width: "30%", // Mengecilkan gambar menjadi 30% dari container
									marginTop: "-10px", // Kurangi margin atas agar lebih proporsional
								}}
							/>
							<Typography
								variant="body2"
								sx={{
									marginTop: "-5px", // Kurangi jarak antara gambar dan teks
									fontWeight: "300",
									color: "primary.main",
								}}
							>
								We're Here to <span style={{ fontWeight: "bold" }}>Help!</span>
							</Typography>
							<Button
								variant="contained"
								color="primary"
								sx={{
									textTransform: "none",
									boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.05)",
									width: "fit-content",
									fontSize: "0.8rem", // Sesuaikan ukuran font tombol
									padding: "4px 12px", // Kurangi padding tombol agar lebih kecil
								}}
								href={"https://wa.me/" + getContactPersonNumber()}
								target="_blank"
							>
								Help Center
							</Button>
						</Box>
				}
				{/* <Divider
					sx={{
						background: theme.colors.alpha.trueWhite[10],
					}}
				/> */}
			</SidebarWrapper>
			<Drawer
				sx={{
					boxShadow: `${theme.sidebar.boxShadow}`,
				}}
				anchor={theme.direction === "rtl" ? "right" : "left"}
				open={sidebarToggle}
				onClose={closeSidebar}
				variant="temporary"
				id="sidebar-drawer"
				elevation={9}>
				<SidebarWrapper
					sx={{
						background:
							theme.palette.mode !== "dark"
								? theme.colors.alpha.white[100]
								: darken(theme.colors.alpha.black[100], 0.5),
					}}>
					<Scrollbar>
						<Box
							pt={2}
							pl={2}
							pb={2}
							mx={1}
							sx={{
								width: 265,
								position: "fixed",
								zIndex: 999,
								background: "#F9FAFC",
								boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.05)",
								padding: "22px 34px",
							}}>
							<Logo />
						</Box>
						<Box mt={10}>
							{isLoggedIn() && <UserBox nameUser={true} />}
						</Box>
						<Divider
							sx={{
								mt: theme.spacing(3),
								mx: theme.spacing(2),
								background: theme.colors.alpha.trueWhite[10],
							}}
						/>
						<SidebarMenu />
					</Scrollbar>
				</SidebarWrapper>
			</Drawer>
		</>
	);
}

export default Sidebar;
